export enum GiftProcessors {
    FOCUS = 1,
    FOCUSCA = 2
}